import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import {AuthenticationHelper} from "../helpers/authenticationHelper";
import {UtilityHelper} from "../helpers/utilityHelper";
import { shouldRedirectToWaitingListFromStorage } from "../helpers/openAccessWaitingList.helper";
import {
    isPhoneVerificationMandatory,
    getPhoneVerificationPolicyState,
    shouldShowPhoneVerificationPrompt
} from "../helpers/phoneVerificationPolicy.helper";
import { AppConstant } from "../app.constant";

@Injectable()
export class LoginGuard implements CanActivate {
    constructor(private authService: AuthenticationHelper, private route: Router, private utility: UtilityHelper) {

    }

    canActivate(_route?: ActivatedRouteSnapshot, state?: RouterStateSnapshot) {
        if (state?.url?.includes('/signout') || AppConstant.isSignOutInProgress()) {
            return true;
        }

        if (this.authService.isLoggedIn()) {
            const userId = this.utility.getItem('userId') || this.utility.getItem('phone_verification_user_id');
            const pendingPhone = this.utility.getItem('phone_number_collection_pending') === 'true';
            const isMandatory = userId ? isPhoneVerificationMandatory(this.utility, userId) : false;
            const policyState = userId ? getPhoneVerificationPolicyState(this.utility, userId) : null;
            const isRequired = policyState?.phone_verification_required === true;
            const shouldPrompt = userId && isRequired ? shouldShowPhoneVerificationPrompt(this.utility, userId, true) : false;
            if (userId && (pendingPhone || isMandatory || shouldPrompt)) {
                this.route.navigate(['/add-phone-number']);
                return false;
            }

            if (shouldRedirectToWaitingListFromStorage(this.utility)) {
                this.route.navigate(['/waiting-list']);
                return false;
            }
            return true;
        } else {
            this.route.navigate(['']);
            return false;
        }
    }
}